import { render, staticRenderFns } from "./applink-popup.vue?vue&type=template&id=698bff30&scoped=true&"
import script from "./applink-popup.vue?vue&type=script&lang=js&"
export * from "./applink-popup.vue?vue&type=script&lang=js&"
import style0 from "./applink-popup.vue?vue&type=style&index=0&id=698bff30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698bff30",
  null
  
)

export default component.exports